<template>
    <div
        class="three-list switchTarget"
        :class="{ opened: opened }"
    >
        <div class="listBody">
            <!-- 打席モード -->
            <!-- <v-touch tag="div" @pinch="invalidPinch($event)" class="listWrapper" v-if="mode === 'atBat'"> -->
            <div
                v-if="mode === 'atBat'"
                class="listWrapper"
            >
                <div class="balls_atBat">
                    <div
                        v-if="allBalls === null"
                        class="noAtBatBalls"
                    >
                        <p class="text">
                            対戦データ解析から<br>投球を選択してください
                        </p>
                        <router-link
                            to="./vsDataList"
                            class="link"
                        >
                            対戦データ解析
                        </router-link>
                    </div>
                    <v-touch
                        v-for="(d, index) in allBalls"
                        :key="d.id"
                        tag="p"
                        :class="nowID === index ? 'ball now' : 'ball'"
                        @tap="playing ? '' : singlePitch(index)"
                    >
                        第{{ d.pitchingdata.PA !== undefined ? d.pitchingdata.PA : ' - ' }}打席　{{
                            index + 1
                        }}球目　{{ setting.typesOfBall[d.pitchingdata.TaggedPitchType].name }}
                    </v-touch>
                </div>
                <!-- </v-touch> -->
            </div>

            <!-- 比較モード -->
            <div
                v-else
                class="listWrapper"
            >
                <v-touch
                    tag="div"
                    class="filter"
                    @pinch.prevent
                >
                    <v-touch
                        tag="div"
                        class="filterBtn"
                        @tap="changeFilterListFlg()"
                    >
                        <p>
                            <span>{{
                                sortMode === 0 ? '登録順' : sortMode === 1 ? '球種別' : 'PTレビュー球'
                            }}</span><span
                                class="icon-arrow-down"
                            />
                        </p>
                    </v-touch>
                    <v-touch
                        v-if="sortMode !== 2"
                        tag="p"
                        class="openSearchBtn"
                        @tap="openSearchModal('compare')"
                    >
                        <span class="icon-search" />
                    </v-touch>
                    <div
                        v-if="filterListFlg === true"
                        class="filterList"
                    >
                        <v-touch
                            v-if="sortMode !== 0"
                            tag="p"
                            @tap="changeSortMode(0)"
                        >
                            登録順
                        </v-touch>
                        <v-touch
                            v-if="sortMode !== 1"
                            tag="p"
                            @tap="changeSortMode(1)"
                        >
                            球種別
                        </v-touch>
                        <v-touch
                            v-if="sortMode !== 2 && PTReviewBalls.length > 0"
                            tag="p"
                            @tap="changeSortMode(2)"
                        >
                            PTレビュー球
                        </v-touch>
                    </div>
                </v-touch>

                <!-- 比較球リスト -->
                <div class="balls_compare">
                    <div
                        v-if="savedBalls.length === 0 && sortMode !== 2"
                        class="noSavedBalls"
                    >
                        <p class="text">
                            比較球を追加してください
                        </p>
                    </div>

                    <div
                        v-if="sortMode === 0"
                        class="ballWrapper"
                    >
                        <div
                            v-for="(d, index) in savedBalls"
                            :key="d.id"
                            class="ball"
                        >
                            <div class="pitcher">
                                <p
                                    class="team"
                                    :class="{styleLongName: d.team.name.length > 9}"
                                >
                                    {{ d.team.name }}
                                </p>
                                <p class="player">
                                    <span class="no">{{ d.pitcher.uniform_number }}</span>&nbsp;&nbsp;&nbsp;<span
                                        class="name"
                                    >{{ d.pitcher.name }}</span>
                                </p>
                            </div>
                            <table class="ballInfo">
                                <tr>
                                    <td class="item">
                                        試合日
                                    </td>
                                    <td class="value">
                                        {{ $d(d.data.timestamp).format("YYYY/MM/DD") }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="item">
                                        球場
                                    </td>
                                    <td class="value">
                                        {{
                                            d.data.pitchingdata.Stadium in listOfStadiums ? listOfStadiums[d.data.pitchingdata.Stadium].additional.name_short : d.data.pitchingdata.Stadium
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="item">
                                        球種
                                    </td>
                                    <td class="value">
                                        {{
                                            setting.typesOfBall[d.data.pitchingdata.TaggedPitchType].name
                                        }}
                                    </td>
                                </tr>
                            </table>
                            <div class="expand">
                                <table class="ballInfo">
                                    <tr>
                                        <td class="item">
                                            球速
                                        </td>
                                        <td class="value">
                                            {{
                                                Math.round(d.data.pitchingdata.RelSpeed / 1000 * 10) / 10
                                            }}km/h
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="item">
                                            回転速度
                                        </td>
                                        <td class="value">
                                            <span v-if="d.data.pitchingdata.SpinRate !== null">{{
                                                Math.round(d.data.pitchingdata.SpinRate * 10) / 10
                                            }}rpm</span>
                                            <span v-else>-</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="item">
                                            α
                                        </td>
                                        <td class="value">
                                            <span v-if="d.data.pitchingdata.Rifle !== null">{{
                                                Math.round(d.data.pitchingdata.Rifle * 10) / 10
                                            }}°</span>
                                            <span v-else>-</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="item">
                                            結果
                                        </td>
                                        <td class="value">
                                            {{
                                                getResultText(d.data.pitchingdata.PitchCall, d.data.pitchingdata.HitType)
                                            }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <v-touch
                                tag="span"
                                class="icon-delete dustBox"
                                @tap="removeSavedBall(index)"
                            />
                            <div class="icons">
                                <svg
                                    width="20"
                                    height="20"
                                    class="ballColor"
                                >
                                    <v-touch
                                        tag="circle"
                                        cx="10"
                                        cy="11"
                                        r="6"
                                        :fill="d.ballColor"
                                    />
                                </svg>
                                <v-touch
                                    v-if="d.enabled"
                                    tag="span"
                                    class="icon-view view enable"
                                    @tap="toggleSavedBall(false, index)"
                                />
                                <v-touch
                                    v-else
                                    tag="span"
                                    class="icon-view view disable"
                                    @tap="toggleSavedBall(true, index)"
                                />
                                <v-touch
                                    tag="span"
                                    class="icon-arrow-up arrow arrowClose"
                                    @tap="close($event)"
                                />
                                <v-touch
                                    tag="span"
                                    class="icon-arrow-down arrow arrowOpen"
                                    @tap="open($event)"
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        v-else-if="sortMode === 1"
                        class="ballWrapper"
                    >
                        <div
                            v-for="(key) in Object.keys(priority).filter(k => sortedArray[k].length !== 0)"
                            class="ballBlock"
                        >
                            <div class="pitchTypeName">
                                <p>{{ pitchTypeName[key] }}</p>
                            </div>
                            <div
                                v-for="(d) in sortedArray[key]"
                                class="ball"
                            >
                                <div class="pitcher">
                                    <p class="team">
                                        {{ d.team.name }}
                                    </p>
                                    <p class="player">
                                        <span class="no">{{ d.pitcher.uniform_number }}</span>&nbsp;&nbsp;&nbsp;<span
                                            class="name"
                                        >{{ d.pitcher.name }}</span>
                                    </p>
                                </div>
                                <table class="ballInfo">
                                    <tr>
                                        <td class="item">
                                            試合日
                                        </td>
                                        <td class="value">
                                            {{ $d(d.data.timestamp).format("YYYY/MM/DD") }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="item">
                                            球場
                                        </td>
                                        <td class="value">
                                            {{
                                                d.data.pitchingdata.Stadium in listOfStadiums ? listOfStadiums[d.data.pitchingdata.Stadium].additional.name_short : d.data.pitchingdata.Stadium
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="item">
                                            球種
                                        </td>
                                        <td class="value">
                                            {{ setting.typesOfBall[d.data.pitchingdata.TaggedPitchType].name }}
                                        </td>
                                    </tr>
                                </table>
                                <div class="expand">
                                    <table class="ballInfo">
                                        <tr>
                                            <td class="item">
                                                球速
                                            </td>
                                            <td class="value">
                                                {{ Math.round(d.data.pitchingdata.RelSpeed / 1000 * 10) / 10 }}km/h
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                回転速度
                                            </td>
                                            <td class="value">
                                                <span v-if="d.data.pitchingdata.SpinRate !== null">{{
                                                    Math.round(d.data.pitchingdata.SpinRate * 10) / 10
                                                }}rpm</span>
                                                <span v-else>-</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                α
                                            </td>
                                            <td class="value">
                                                <span v-if="d.data.pitchingdata.Rifle !== null">{{
                                                    Math.round(d.data.pitchingdata.Rifle * 10) / 10
                                                }}°</span>
                                                <span v-else>-</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="item">
                                                結果
                                            </td>
                                            <td class="value">
                                                {{
                                                    getResultText(d.data.pitchingdata.PitchCall, d.data.pitchingdata.HitType)
                                                }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <v-touch
                                    tag="span"
                                    class="icon-delete dustBox"
                                    @tap="removeSortBall(d.defaultNum, key)"
                                />
                                <div class="icons">
                                    <svg
                                        width="20"
                                        height="20"
                                        class="ballColor"
                                    >
                                        <v-touch
                                            tag="circle"
                                            cx="10"
                                            cy="11"
                                            r="6"
                                            :fill="d.ballColor"
                                            @tap="changeBaseBall(d.defaultNum)"
                                        />
                                        <circle
                                            v-if="mode === 'tunnnel' && baseBallIndex === d.defaultNum"
                                            cx="10"
                                            cy="11"
                                            r="8"
                                            fill="none"
                                            stroke="#fff"
                                        />
                                    </svg>
                                    <v-touch
                                        v-if="d.enabled"
                                        tag="span"
                                        class="icon-view view enable"
                                        @tap="toggleSavedBall(false, d.defaultNum)"
                                    />
                                    <v-touch
                                        v-else
                                        tag="span"
                                        class="icon-view view disable"
                                        @tap="toggleSavedBall(true, d.defaultNum)"
                                    />
                                    <v-touch
                                        tag="span"
                                        class="icon-arrow-up arrow arrowClose"
                                        @tap="close($event)"
                                    />
                                    <v-touch
                                        tag="span"
                                        class="icon-arrow-down arrow arrowOpen"
                                        @tap="open($event)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ピッチトンネル比較モードレビュー -->
                    <div
                        v-else-if="sortMode === 2"
                        class="ballWrapper"
                    >
                        <div
                            v-for="(d, index) in PTReviewBalls"
                            :key="d.id"
                            class="ball"
                        >
                            <div class="pitcher">
                                <p
                                    class="team"
                                    :class="{styleLongName: d.team.name.length > 9}"
                                >
                                    {{ d.team.name }}
                                </p>
                                <p class="player">
                                    <span class="no">{{ d.pitcher.uniform_number }}</span>&nbsp;&nbsp;&nbsp;<span
                                        class="name"
                                    >{{ d.pitcher.name }}</span>
                                </p>
                            </div>
                            <table class="ballInfo">
                                <tr>
                                    <td class="item">
                                        試合日
                                    </td>
                                    <td class="value">
                                        {{ $d(d.data.timestamp).format("YYYY/MM/DD") }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="item">
                                        球種
                                    </td>
                                    <td class="value">
                                        {{
                                            setting.typesOfBall[d.data.pitchingdata.TaggedPitchType].name
                                        }}
                                    </td>
                                </tr>
                            </table>
                            <div class="expand">
                                <table class="ballInfo">
                                    <tr>
                                        <td class="item">
                                            球速
                                        </td>
                                        <td class="value">
                                            {{
                                                Math.round(d.data.pitchingdata.RelSpeed / 1000 * 10) / 10
                                            }}km/h
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="item">
                                            回転速度
                                        </td>
                                        <td class="value">
                                            <span v-if="d.data.pitchingdata.SpinRate !== null">{{
                                                Math.round(d.data.pitchingdata.SpinRate * 10) / 10
                                            }}rpm</span>
                                            <span v-else>-</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="item">
                                            α
                                        </td>
                                        <td class="value">
                                            <span v-if="d.data.pitchingdata.Rifle !== null">{{
                                                Math.round(d.data.pitchingdata.Rifle * 10) / 10
                                            }}°</span>
                                            <span v-else>-</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="item">
                                            結果
                                        </td>
                                        <td class="value">
                                            {{
                                                getResultText(d.data.pitchingdata.PitchCall, d.data.pitchingdata.HitType)
                                            }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <!-- <v-touch tag="span" class="icon-delete dustBox" @tap="removeSavedBall(index )"></v-touch> -->
                            <div class="icons">
                                <svg
                                    width="20"
                                    height="20"
                                    class="ballColor"
                                >
                                    <v-touch
                                        tag="circle"
                                        cx="10"
                                        cy="11"
                                        r="6"
                                        :fill="d.ballColor"
                                    />
                                </svg>
                                <v-touch
                                    v-if="d.enabled"
                                    tag="span"
                                    class="icon-view view enable"
                                    @tap="toggleSavedBall(false, index)"
                                />
                                <v-touch
                                    v-else
                                    tag="span"
                                    class="icon-view view disable"
                                    @tap="toggleSavedBall(true, index)"
                                />
                                <v-touch
                                    tag="span"
                                    class="icon-arrow-up arrow arrowClose"
                                    @tap="close($event)"
                                />
                                <v-touch
                                    tag="span"
                                    class="icon-arrow-down arrow arrowOpen"
                                    @tap="open($event)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="opener">
                <v-touch
                    v-if="opened"
                    tag="p"
                    class="icon-arrow-left"
                    @tap="opened = false"
                />
                <v-touch
                    v-else
                    tag="p"
                    class="icon-arrow-right"
                    @tap="opened = true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Common3dList from '@/components_common/3d/List.vue'
import {mapGetters} from "vuex"

export default {
    name: 'ThreeList',
    mixins: [Common3dList],
    computed: {
        ...mapGetters(['listOfStadiums'])
    }
}
</script>

<style scoped>
.three-list {
    position: absolute;
    top: 45px;
    transition: .2s;
    left: -230px;
    z-index: 2;
    height: calc(100% - 45px);
}

.three-list.opened {
    left: 0;
}

.listBody {
    background: rgba(34, 34, 34, 0.85);
    width: 230px;
    /*  height: 723px;*/
    /*  height: calc(100vh - 45px);*/
    height: 100%;
    color: #fff;
    overflow: hidden;
}

.listWrapper {
    width: 230px;
    /*height: calc(100vh -45px);*/
    height: 100%;
    overflow: hidden;
}

.pitcher {
    padding: 12px 15px 2px;
    font-size: 13px;
}

.pitcher .team,
.pitcher .player {
    margin: 8px 0;
}

.balls_compare {
    height: calc(100% - 25px);
    padding-top: 10px;
    padding-bottom: 10px;
    box-sizing: border-box;
}

.balls_compare .pitcher {
    padding: 0;
    margin: 0 0 10px;
}

.balls_compare .pitcher .team,
.balls_compare .pitcher .player {
    margin: 0;
}

.balls_compare .pitcher .team.styleLongName {
    transform-origin: top left;
    transform: scale(0.8, 1);
    width: 240px;
}

.balls_compare .pitcher .player {
    margin-top: 8px;
}

.balls_atBat,
.balls_compare {
    margin: 0 10px;
    overflow: auto;
}

.ball {
    font-size: 12px;
    background: rgba(51, 51, 51, 0.95);
    line-height: 12px;
    margin: 10px 0;
    padding: 10px 10px 40px 10px;
    position: relative;
    color: rgba(255, 255, 255, 0.35);
    /*cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;*/
}

.balls_atBat .ball {
    padding: 10px;
}

.ball:nth-child(1) {
    margin-top: 0;
}

.balls_compare .ball,
.ball.now {
    color: rgba(255, 255, 255, 1);
}

.pitchTypeName {
    margin: 15px 5px 5px;
}

.ballBlock:nth-child(1) .pitchTypeName {
    margin-top: 5px;
}

.ball .ballInfo {
    font-size: 12px;
    margin: 10px 0 0;
    width: 100%;
}

.ball .expand {
    transition: .2s;
    max-height: 0;
}

.ball .expand .ballInfo {
    margin-top: 0;
    display: none;
}

.ball .ballInfo td {
    padding: 3px 0;
}

.ball .ballInfo td.item {
    padding-right: 10px;
}

.dustBox {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 20px;
    padding: 10px;
    display: block;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.ballColor {
    margin-right: 10px;
}

.viewLabel {
}

.view.enable {
    font-size: 20px;
    color: rgba(255, 255, 255, 1);
}

.view.disable {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.35);
}

.arrow {
    font-size: 20px;
}

.icons {
    position: absolute;
    bottom: 10px;
    right: 0;
    line-height: 20px;
    height: 20px;
}

.filter {
    height: 45px;
    background: rgba(51, 51, 51, 0.95);
    position: relative;
    padding: 12px 15px;
    display: flex;
    cursor: pointer;
}

.filterBtn p span {
    width: auto;
    height: 20px;
    float: left;
    padding-top: 2px;
}

.filterBtn p span.icon-arrow-down {
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding-top: 0;
    font-size: 20px;
    float: right;
    color: #bbb;
}

.openSearchBtn {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
}

.openSearchBtn span {
    padding: 10px;
    font-size: 25px;
}

.filterList {
    width: 220px;
    height: auto;
    background: rgba(85, 85, 85, 0.95);
    position: absolute;
    padding: 0 10px;
    margin: 0 5px;
    top: 45px;
    left: 0;
    z-index: 2;
    cursor: pointer;
}

.filterList p {
    display: block;
    margin: 20px 0;
}

.ball .view {
    padding: 10px;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.ball .arrowClose {
    display: none;
    padding: 10px;
    color: #bbb;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.ball.open .arrowClose {
    display: inline;
}

.ball .arrowOpen {
    display: inline;
    padding: 10px;
    color: #bbb;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.ball.open .arrowOpen {
    display: none;
}

[type="checkbox"] {
    border: solid 1px #999;
    background-color: #fff;
    width: 12px;
    height: 12px;
}

[type="checkbox"]:checked {
    opacity: 1;
    background: #ff0000;
}

.opener {
    position: absolute;
    top: 50px;
    right: -20px;
    width: 20px;
    height: 35px;
    background: rgba(34, 34, 34, 0.85);
}

.opener .icon-arrow-left,
.opener .icon-arrow-right {
    font-size: 20px;
    line-height: 35px;
    color: #bbb;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.item {
    width: 35%;
}

.value {
    width: 65%;
}

.noSavedBalls {
    margin: 20px 10px;
}

.noAtBatBalls {
    margin: 20px 10px;
}

.noAtBatBalls .link {
    display: block;
    color: #fff;
    font-size: 12px;
    margin-top: 10px;
    border: solid 1px #fff;
    line-height: 23px;
    text-align: center;
}

.ballWrapper {
    width: 210px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 10px;
}

.platform-ipad .ball:last-child,
.platform-ipad .ballBlock:last-child {
    margin-bottom: 20px;
}

.tab704 .ballWrapper > .ball:last-child,
.tab704 .ballWrapper > .ballBlock:last-child {
    margin-bottom: 45px;
}

.tab672 .ballWrapper > .ball:last-child,
.tab672 .ballWrapper > .ballBlock:last-child {
    margin-bottom: 80px;
}
</style>
